module.exports = __webpack_public_path__ + "static/map_locator-cd1e7e6b2691fd11a79fd41bdaf67afb.jpg";